import { motion } from 'framer-motion';
import { Award, Users, TrendingUp, Target } from 'lucide-react';

export const AboutStats = () => (
  <section className="py-24 bg-[#0f172a]" data-testid="about-stats">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
        {[
          { icon: <Award />, number: '10+', label: 'Years of Excellence' },
          { icon: <Users />, number: '500+', label: 'Clients Served' },
          { icon: <TrendingUp />, number: '₹1000Cr+', label: 'Funds Facilitated' },
          { icon: <Target />, number: '98%', label: 'Success Rate' }
        ].map((stat, index) => (
          <motion.div
            key={stat.label}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            className="text-center"
          >
            <div className="inline-flex items-center justify-center w-12 h-12 bg-white/10 rounded-xl text-[#00bcd4] mb-4">
              {stat.icon}
            </div>
            <p className="text-4xl lg:text-5xl font-semibold text-white font-mono mb-2">{stat.number}</p>
            <p className="text-slate-400 text-sm">{stat.label}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
